<section class="body">
  <div class="container-fluid">
    <div class="row bg-white">
      <div class="col-md-6 p-0">
        <div style="  background-image: url(assets/img/new/login-bg.png); background-repeat: no-repeat; background-size: cover;">
          <div class="px-3 pt-4 pb-2 text-center">
            <img   src="assets/img/new/sign-bg.png" />
            <div class="pt-3 pl-3 text-left">
              <img src="assets/img/new/black-logo.png" width="150" height="60"/>
              <h4 class="text-white font-36 l-h55">Welcome To FastSwiff <span class="d-block">Virtual Terminal</span></h4>
              <div class="border-white-line"></div>
              <p class="text-white pt-2 l-h21 font200">Virtual Terminal has a great new look and feel, ready for you to continue your clients payment processing. Click the Register Button to be redirected to the new login page.</p>
              <div class="row py-3">
                <div class="col-md-3">
                  <img class="d-inline" src="assets/img/new/icon-awesome-phone.svg"/> 
                  <p class="text-white pt-2 l-h21 font200 d-inline ml-2">+917337327109</p>
                </div>
                <div class="col-md-3">
                  <img class="d-inline" src="assets/img/new/ionic-md-mail.svg"/> 
                  <p class="text-white pt-2 l-h21 font200 d-inline ml-2">care@fastswiff.com</p>
                </div>
                <div class="col-md-6 text-right pr-5 pb-2">
                  <div class="social-icons text-right  poppins">
                    <a  href="https://www.facebook.com/FastSwiffIndia/" target="_blank" ><i class="fab fa-facebook"></i></a>  <a href="https://twitter.com/FastSwiffIndia"  target="_blank"><i class="fab fa-twitter"></i></a>
                    <a href="https://www.instagram.com/paygindia/"  target="_blank"><i class="fab fa-instagram"></i></a>
                    <a href="https://www.linkedin.com/company/pay-g"  target="_blank"><i class="fab fa-linkedin-in"></i></a>
                    <a href="https://www.youtube.com/watch?v=IEbSqP5Q18Y"  target="_blank"><i class="fab fa-youtube"></i></a>
                    <a href="https://in.pinterest.com/paygindia/"  target="_blank"><i class="fab fa-pinterest-p"></i></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-5 p-0 bg-white">
        <div class="sign-p">
          <h6 class="font-16 gray-t">Sign In</h6>
          <h4 class="font-30 gray-t l-h46">Get Started</h4>
          <h5 class="font-20 l-h30 pb-2">Please Fill your details to login your account</h5>
          <form  #loginform="ngForm" (ngSubmit)="login()">
            <div class="form-group ">
                <div data-validate="Valid email is required: ex@abc.xyz">
                  <input type="text" placeholder="PosSubscription Id"  id="PosSubscriptionId" name="PosSubscriptionId" [formControl]="PosSubscriptionId" required class="formcontrol-user form-control" >
                </div>
              </div>
          <div class="form-group ">
            <div data-validate="Valid email is required: ex@abc.xyz">
              <input type="text" placeholder="Employee Id"  id="employeeid" name="employeeid" [formControl]="employeeid" required class="formcontrol-user form-control">
            </div>
          </div>
          <div class="form-group">
            <div   data-validate="Password is required">
              <input  class="formcontrol-user form-control" placeholder="Pass Code"  type="password" id="passcode" [formControl]="passcode" name="passcode" aria-label="passcode"
              required>
            </div>
            <!-- <span class="text-danger"
          *ngIf="password.invalid && (password.dirty || password.touched)">{{passworderrors()}} </span>
        <small style="color:red;" *ngIf="isloginfailed">UserName or Password is Invalid</small> -->

            <!-- <a [routerLink]="['/registration/forgotpassword']" class="text-danger py-1" style="float:right;font-size:12px;">Forgot password?</a> -->
          </div>
          <button type="submit" class="btn btn-create ">Log in</button>
        </form>
        
        </div>
      </div>
    </div>
  </div>
</section>


  